export function formatLocationDisplayName(location) {
  if (!location) {
    return "";
  }
  const name = location.place_name || location.name || "";
  const info = (location.info || location.suggest_info || "").toString().trim();
  return info !== "" ? `${name}, ${info}` : name;
}

const geo = {
  geoToCookies() {
    if(vueOptions.ssr) {
      return;
    }
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        document.cookie = "BITRIX_SM_LATITUDE="+position.coords.latitude+";path=/;domain="+fakeWindow.location.hostname+";expires="+60+"";
        document.cookie = "BITRIX_SM_LONGITUDE="+position.coords.longitude+";path=/;domain="+fakeWindow.location.hostname+";expires="+60+"";
      });
    }
  },
};

export { geo };
